import React, { useState, useEffect } from 'react'
import MUIDataTable from 'mui-datatables'
import { useDispatch } from 'react-redux'
import Box from '@material-ui/core/Box'
import { IconButton, Link, Button } from '@material-ui/core'
import CircularProgress from '@material-ui/core/CircularProgress'
import { HeaderTableCell } from '../containers'
import { OPEN_ALERT } from '../../redux/alertReducer'
import { useAuth0 } from '@auth0/auth0-react'
import ApiClient from '../../common/ApiClient'
import DeleteIcon from '@material-ui/icons/Delete'

export default function EntitlementAdminsTableForContainerHub({
  entitlementId,
  admins,
  isLoading,
  setNeedsFetchData,
  entitlement,
}) {
  const { getAccessTokenSilently } = useAuth0()
  const dispatch = useDispatch()
  const [loadingEmail, setLoadingEmail] = useState(null)

  useEffect(() => {
    setLoadingEmail(null)
  }, [admins])

  const unassign = (email) => async () => {
    if (loadingEmail) return
    const showError = () =>
      dispatch({
        type: OPEN_ALERT,
        msg: 'Error occurred and the admin has not been unassigned.',
        severity: 'error',
        action: (
          <Link href="mailto:SMB-myAdvantest-Admin@advantest.com">
            <Button variant="contained" color="primary" size="small">
              Contact support
            </Button>
          </Link>
        ),
      })
    setLoadingEmail(email)
    const token = await getAccessTokenSilently()
    await ApiClient.delete(`/v2/assignment?application=${entitlement.application}`, token, {
      entitlementId,
      email,
      isAdmin: true,
    })
      .then((response) => {
        if (response && response.status === 200) {
          setNeedsFetchData(true)
          dispatch({
            type: OPEN_ALERT,
            msg: `Admin (${email}) has been unassigned from the entitlement.`,
            severity: 'success',
          })
        } else {
          showError()
          setLoadingEmail(null)
        }
      })
      .catch(() => {
        showError()
        setLoadingEmail(null)
      })
  }

  const columns = [
    {
      name: 'email',
      label: 'Email',
      options: {
        customHeadRender: () => (
          <HeaderTableCell key="email">Email</HeaderTableCell>
        ),
      },
    },
    {
      name: 'unassignUser',
      label: 'Unassign',
      options: {
        customHeadRender: () => (
          <HeaderTableCell key="unassignUser">Unassign</HeaderTableCell>
        ),
        customBodyRenderLite: (dataIndex) => {
          const email = admins[dataIndex].email
          return (
            <IconButton
              onClick={unassign(email)}
              color="primary"
              disabled={loadingEmail !== null}
            >
              {loadingEmail === email ? (
                <CircularProgress size={20} />
              ) : (
                <DeleteIcon />
              )}
            </IconButton>
          )
        },
      },
    },
  ]

  const options = {
    elevation: 4,
    download: false,
    selectableRowsHeader: false,
    selectableRowsHideCheckboxes: true,
    filterType: 'dropdown',
    responsive: 'vertical',
    print: false,
    filter: false,
    viewColumns: false,
    count: admins.length,
    textLabels: {
      body: {
        noMatch: isLoading ? (
          <CircularProgress size={30} />
        ) : (
          'Sorry, there is no matching data to display'
        ),
      },
    },
  }

  return (
    <Box sx={{ marginTop: '8px' }}>
      <MUIDataTable
        style={{ marginTop: '8px' }}
        key="EntitlementAdmins"
        title={'Admins'}
        data={admins}
        columns={columns}
        options={options}
      />
    </Box>
  )
}